module.exports = __webpack_public_path__ + "media/images/sync-shop-efc8b1f4bfcffceb9d1d8ef3061e95bd.png";